export enum EventName {
  X_IMPRESSION = "x_impression",
  X_CLICK = "x_click",
  X_CUSTOM = "x_custom",

  X_REQUEST_CREATED = "x_request_created",
  X_REQUEST_FORM_STEP = "x_request_form_step",
  X_REQUEST_FORM_FIELD_SAVED = "x_request_form_field_saved",
  X_REQUEST_FORM_FINISHED = "x_request_form_finished",

  X_FORM_ABANDONED = "x_form_abandoned",

  X_VIDEO = "x_video",

  WIDGET_UNI_SUBMIT = "widget_uni_submit",
}